import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { API_BASE_URL } from "./config";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button, Card, Col, Row } from "react-bootstrap";
import axios from "axios";

const Turmas = () => {
    const [turmas, setTurmas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [turmaDataToEdit, setTurmaDataToEdit] = useState(null);
    const [showModalExcluir, setShowModalExcluir] = useState(false);
    const [turmaParaExcluir, setTurmaParaExcluir] = useState(null);
    const [showModalConfirmAcao, setShowModalConfirmAcao] = useState(false);
    const [turmaParaAcao, setTurmaParaAcao] = useState(null);
    const [tipoAcao, setTipoAcao] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [turmasPerPage, setTurmasPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortDirection, setSortDirection] = useState("asc");
    const [loading, setLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [turmaData, setTurmaData] = useState(null);
    const [alunosFiltrados, setAlunosFiltrados] = useState([]);
    const location = useLocation();
    const returnTo = `${location.pathname}${location.search}${location.hash || ""}`;

    const formatDateBR = (dateString) => {
        if (!dateString) return "";
        const datePart = String(dateString).split("T")[0];
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
            const [ano, mes, dia] = datePart.split("-");
            return `${dia}/${mes}/${ano}`;
        }
        return new Date(dateString).toLocaleDateString("pt-BR");
    };

    const confirmarAcao = async () => {
        if (!turmaParaAcao || !tipoAcao) return;
        try {
            if (tipoAcao === "finalizar") {
                await axios.put(`${API_BASE_URL}/turmas/${turmaParaAcao.cp_tr_id}/finalizar`, {}, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
            }
            if (tipoAcao === "reativar") {
                await axios.put(`${API_BASE_URL}/turmas/${turmaParaAcao.cp_tr_id}/reativar`, {}, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
            }
            fetchTurmas();
        } catch (error) {
            console.error("Erro ao atualizar status da turma:", error);
        } finally {
            fecharModalConfirmAcao();
        }
    };

    useEffect(() => {
        fetchTurmas();
    }, []);

    const userType = parseInt(localStorage.getItem('userType'), 10) || 0;
    const userName = localStorage.getItem("userName");
    const schoolId = localStorage.getItem("schoolId");
    const podeEditar = !(userType === 4 || userType === 5);

    const enrichTurmasWithCursoNome = async (turmasBase) => {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const uniqueCourseIds = [
            ...new Set(
                (Array.isArray(turmasBase) ? turmasBase : [])
                    .map((turma) => Number(turma.cp_tr_curso_id))
                    .filter((cursoId) => Number.isFinite(cursoId) && cursoId > 0)
            ),
        ];

        if (uniqueCourseIds.length === 0) {
            return turmasBase;
        }

        const cursos = await Promise.all(
            uniqueCourseIds.map(async (cursoId) => {
                try {
                    const responseCurso = await axios.get(`${API_BASE_URL}/cursos/${cursoId}`, { headers });
                    return [cursoId, responseCurso.data?.cp_nome_curso || "-"];
                } catch (error) {
                    console.error("Erro ao buscar curso da turma:", error);
                    return [cursoId, "-"];
                }
            })
        );

        const cursoNomePorId = new Map(cursos);
        return turmasBase.map((turma) => ({
            ...turma,
            cursoNome: cursoNomePorId.get(Number(turma.cp_tr_curso_id)) || turma.cursoNome || "-",
        }));
    };


    const fetchTurmas = async () => {
        setLoading(true);
        try {
            const endpoint = userType === 5 ? '/turmasComAlunos' : '/turmas';
            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            const data = await response.json();
            
            const numericSchoolId = Number(schoolId);
            const hasSchoolId = Number.isFinite(numericSchoolId) && numericSchoolId > 0;
            let turmasFiltradas = hasSchoolId
                ? data.filter((turma) => Number(turma.cp_tr_id_escola) === numericSchoolId)
                : data;

            if (userType === 4) {
                turmasFiltradas = turmasFiltradas
                    .filter(turma => turma.nomeDoProfessor === userName)
                    .filter(turma => Number(turma.cp_tr_inativa) !== 1);
            }
            if (userType === 5) {
                turmasFiltradas = await enrichTurmasWithCursoNome(turmasFiltradas);
            }

            setTurmas(turmasFiltradas);
        } catch (error) {
            console.error("Erro ao buscar turmas:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (turmaId) => {
        try {
            await fetch(`${API_BASE_URL}/delete-turma/${turmaId}`, {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            fetchTurmas();
        } catch (error) {
            console.error("Erro ao excluir turma:", error);
        }
    };

    const handleConfirmarExclusao = async () => {
        if (turmaParaExcluir) {
            try {
                await fetch(
                    `${API_BASE_URL}/delete-turma/${turmaParaExcluir.cp_tr_id}`,
                    { 
                        method: "DELETE",
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );
                fetchTurmas();
            } catch (error) {
                console.error("Erro ao excluir turma:", error);
            } finally {
                fecharModalExcluir();
            }
        }
    };

    const openDeleteModal = (turma) => {
        setTurmaParaExcluir(turma);
        setShowModalExcluir(true);
    };

    const fecharModalExcluir = () => {
        setShowModalExcluir(false);
        setTurmaParaExcluir(null);
    };

    const abrirModalConfirmAcao = (acao, turma) => {
        setTipoAcao(acao);
        setTurmaParaAcao(turma);
        setShowModalConfirmAcao(true);
    };

    const fecharModalConfirmAcao = () => {
        setShowModalConfirmAcao(false);
        setTurmaParaAcao(null);
        setTipoAcao("");
    };

    const handleSortChange = () => {
        const newDirection = sortDirection === "asc" ? "desc" : "asc";
        setSortDirection(newDirection);
        const sortedTurmas = [...turmas].sort((a, b) => {
            const nomeA = a.cp_tr_nome.toLowerCase();
            const nomeB = b.cp_tr_nome.toLowerCase();
            return newDirection === "asc"
                ? nomeA.localeCompare(nomeB)
                : nomeB.localeCompare(nomeA);
        });
        setTurmas(sortedTurmas);
    };

    const normalizeText = (value) => {
        return String(value ?? "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .trim();
    };

    const handleSearchChange = (value) => {
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const filteredTurmas = turmas.filter((turma) => {
        const nomeTurma = normalizeText(turma?.cp_tr_nome);
        const termo = normalizeText(searchTerm);
        return nomeTurma.includes(termo);
    });

    const totalPaginas = Math.ceil(filteredTurmas.length / turmasPerPage);
    useEffect(() => {
        if (totalPaginas === 0 && currentPage !== 1) {
            setCurrentPage(1);
            return;
        }
        if (totalPaginas > 0 && currentPage > totalPaginas) {
            setCurrentPage(totalPaginas);
        }
    }, [currentPage, totalPaginas]);

    const paginasVisiveis = [];
    for (
        let i = Math.max(1, currentPage - 2);
        i <= Math.min(totalPaginas, currentPage + 2);
        i++
    ) {
        paginasVisiveis.push(i);
    }

    const currentTurmas = filteredTurmas.slice(
        (currentPage - 1) * turmasPerPage,
        currentPage * turmasPerPage
    );

    const openViewModal = async (turmaId) => {
        const turma = turmas.find((turma) => turma.cp_tr_id === turmaId);
        setShowViewModal(true);
        setTurmaData(turma);

        if (!turma) return;

        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        const cursoId = Number(turma.cp_tr_curso_id);
        if (Number.isFinite(cursoId) && cursoId > 0) {
            try {
                const responseCurso = await axios.get(`${API_BASE_URL}/cursos/${cursoId}`, { headers });
                const curso = responseCurso.data;
                setTurmaData((prevState) => ({
                    ...prevState,
                    cursoNome: curso?.cp_nome_curso || "-",
                }));
            } catch (error) {
                console.error("Erro ao buscar curso da turma:", error);
                setTurmaData((prevState) => ({ ...prevState, cursoNome: "-" }));
            }
        } else {
            setTurmaData((prevState) => ({ ...prevState, cursoNome: "-" }));
        }

        try {
            const responseAlunos = await axios.get(`${API_BASE_URL}/turmas/${turmaId}/alunos`, { headers });
            setAlunosFiltrados(Array.isArray(responseAlunos.data) ? responseAlunos.data : []);
        } catch (error) {
            console.error("Erro ao buscar alunos da turma:", error);
            setAlunosFiltrados([]);
        }
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setTurmaData(null);
        setAlunosFiltrados([]);
    };

    return (
        <div className="card h-100 p-0 radius-12">
            {userType === 5 ? (
                <div className="p-4">
                    {loading ? (
                        <p className="text-center text-muted mb-0">Carregando turmas...</p>
                    ) : turmas.length > 0 ? (
                        <Row className="g-3">
                            {turmas.map((turma) => (
                                <Col xs={12} xl={6} key={turma.cp_tr_id}>
                                    <div className="card-body p-24 border rounded-4 h-100 bg-base">
                                        <Row className="align-items-center g-3">
                                            <Col md={3} className="text-center">
                                                <Icon icon="mdi:school-outline" className="text-primary" width={60} height={60} />
                                            </Col>
                                            <Col>
                                                <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                    <h5 className="mb-0 text-secondary">{turma.cp_tr_nome}</h5>
                                                    {Number(turma.cp_tr_inativa) === 1 && (
                                                        <span className="badge bg-secondary">Inativa</span>
                                                    )}
                                                </div>
                                                <p className="mb-0"><strong>Início:</strong> {formatDateBR(turma.cp_tr_data)}</p>
                                                <p className="mb-0"><strong>Professor:</strong> {turma.nomeDoProfessor}</p>
                                                <p className="mb-0"><strong>Escola:</strong> {turma.nomeDaEscola}</p>
                                                <p className="mb-0"><strong>Curso:</strong> {turma.cursoNome || "-"}</p>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <p className="text-center text-muted mb-0">Nenhuma turma encontrada.</p>
                    )}
                </div>
            ) : (
                <>
                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                        <div className="d-flex align-items-center flex-wrap gap-3">
                            <span className="text-md fw-medium text-secondary-light mb-0">
                                Mostrar
                            </span>
                            <select
                                className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                value={turmasPerPage}
                                onChange={(e) => {
                                    setTurmasPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                            </select>
                            <form className="navbar-search">
                                <input
                                    type="text"
                                    className="bg-base h-40-px w-auto"
                                    placeholder="Pesquisar"
                                    value={searchTerm}
                                    onChange={(e) => handleSearchChange(e.target.value)}
                                />
                                <Icon icon="ion:search-outline" className="icon" />
                            </form>
                            <button
                                className="btn btn-outline-secondary text-md py-6 radius-12 h-40-px d-flex align-items-center gap-2"
                                onClick={handleSortChange}
                            >
                                Ordenar por {sortDirection === "asc" ? "A-Z" : "Z-A"}
                            </button>
                        </div>
                        {podeEditar && (
                            <Link
                                to={`/cadastro-turma/`}
                                state={{ from: returnTo }}
                                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                            >
                                <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                                Adicionar Novo
                            </Link>
                        )}
                    </div>
                    <div className="card-body p-24">
                        <div className="table-responsive scroll-sm">
                            <table className="table bordered-table sm-table mb-0">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Data de Início</th>
                                        <th>Professor</th>
                                        <th>Escola</th>
                                        <th className="text-center">Ação</th>
                                        {/* {podeEditar && <th className="text-center">Ação</th>} */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                Carregando...
                                            </td>
                                        </tr>
                                    ) : (
                                        currentTurmas.map((turma) => (
                                            <tr key={turma.cp_tr_id}>
                                                <td>
                                                    {turma.cp_tr_nome}
                                                    {Number(turma.cp_tr_inativa) === 1 && (
                                                        <span className="ms-2 badge bg-secondary">Inativa</span>
                                                    )}
                                                </td>
                                                <td>{formatDateBR(turma.cp_tr_data)}</td>
                                                <td>{turma.nomeDoProfessor}</td>
                                                <td>{turma.nomeDaEscola}</td>
                                                <td className="text-center">
                                                    {podeEditar && (
                                                        <>
                                                            <Link
                                                                to={`/cadastro-turma/${turma.cp_tr_id}`}
                                                                state={{ from: returnTo }}
                                                                className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                            >
                                                                <Icon icon="lucide:edit" />
                                                            </Link>
                                                            <button
                                                                onClick={() => openDeleteModal(turma)}
                                                                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                            >
                                                                <Icon icon="mingcute:delete-2-line" />
                                                            </button>
                                                        </>
                                                    )}
                                                    {userType === 4 && (
                                                        <button
                                                            onClick={() => abrirModalConfirmAcao("finalizar", turma)}
                                                            className="w-32-px h-32-px me-8 bg-warning-focus text-warning-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        >
                                                            <Icon icon="mdi:check-circle-outline" />
                                                        </button>
                                                    )}
                                                    {(userType === 2 || userType === 3) && Number(turma.cp_tr_inativa) === 1 && (
                                                        <button
                                                            onClick={() => abrirModalConfirmAcao("reativar", turma)}
                                                            className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        >
                                                            <Icon icon="mdi:restore" />
                                                        </button>
                                                    )}

                                                    <Link
                                                        to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            openViewModal(turma.cp_tr_id);
                                                        }}
                                                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="iconamoon:eye-light" />
                                                    </Link>
                                                </td>

                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-24 flex-wrap gap-3">
                            <span>
                                Mostrando {currentPage} de {totalPaginas} páginas
                            </span>
                            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center mb-0">
                                <li className="page-item">
                                    <button
                                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                        onClick={() => setCurrentPage(1)}
                                        disabled={currentPage === 1}
                                    >
                                        <Icon icon="ep:d-arrow-left" />
                                    </button>
                                </li>
                                <li className="page-item">
                                    <button
                                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                    >
                                        Anterior
                                    </button>
                                </li>
                                {paginasVisiveis.map((page) => (
                                    <li
                                        key={page}
                                        className={`page-item ${currentPage === page ? "active" : ""}`}
                                    >
                                        <button
                                            className={`page-link text-md fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px ${currentPage === page
                                                ? "bg-primary-600 text-white"
                                                : "bg-neutral-200 text-secondary-light"
                                                }`}
                                            onClick={() => setCurrentPage(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}
                                {totalPaginas > 5 && currentPage + 2 < totalPaginas && (
                                    <li className="page-item">
                                        <span className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px">
                                            ...
                                        </span>
                                    </li>
                                )}
                                <li className="page-item">
                                    <button
                                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                        onClick={() =>
                                            setCurrentPage((prev) => Math.min(prev + 1, totalPaginas))
                                        }
                                        disabled={currentPage === totalPaginas}
                                    >
                                        Próximo
                                    </button>
                                </li>
                                <li className="page-item">
                                    <button
                                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                        onClick={() => setCurrentPage(totalPaginas)}
                                        disabled={currentPage === totalPaginas}
                                    >
                                        <Icon icon="ep:d-arrow-right" />
                                    </button>
                                </li>
                            </ul>
                            <div className="d-flex align-items-center">
                                <select
                                    className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                    value={currentPage}
                                    onChange={(e) => setCurrentPage(Number(e.target.value))}
                                >
                                    {Array.from({ length: totalPaginas }, (_, idx) => (
                                        <option key={idx + 1} value={idx + 1}>
                                            Página {idx + 1}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                    </div>
                </>
            )}
            <Modal show={showModalExcluir} onHide={fecharModalExcluir} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Exclusão</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja excluir a turma{" "}
                    <strong>{turmaParaExcluir?.cp_tr_nome}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharModalExcluir}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={handleConfirmarExclusao}>
                        Excluir
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalConfirmAcao} onHide={fecharModalConfirmAcao} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {tipoAcao === "finalizar" ? "Finalizar Turma" : "Reativar Turma"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {tipoAcao === "finalizar" ? (
                        <>
                            Tem certeza que deseja finalizar a turma{" "}
                            <strong>{turmaParaAcao?.cp_tr_nome}</strong>? Ela ficará oculta para você, mas continuará existindo.
                        </>
                    ) : (
                        <>
                            Tem certeza que deseja reativar a turma{" "}
                            <strong>{turmaParaAcao?.cp_tr_nome}</strong> para o professor?
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharModalConfirmAcao}>
                        Cancelar
                    </Button>
                    <Button
                        variant={tipoAcao === "finalizar" ? "warning" : "success"}
                        onClick={confirmarAcao}
                    >
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showViewModal} onHide={closeViewModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes da Turma</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Card>
                        <Card.Body>
                            <Card.Title>{turmaData?.cp_tr_nome}</Card.Title>
                            <Card.Text><strong>Data de Início:</strong> {turmaData?.cp_tr_data ? formatDateBR(turmaData.cp_tr_data) : "-"}</Card.Text>
                            <Card.Text><strong>Professor:</strong> {turmaData?.nomeDoProfessor}</Card.Text>
                            <Card.Text><strong>Escola:</strong> {turmaData?.nomeDaEscola}</Card.Text>
                            <Card.Text><strong>Curso:</strong> {turmaData?.cursoNome}</Card.Text>
                            <div>
                                <strong>Alunos da Turma:</strong>
                                <ul>
                                    {Array.isArray(alunosFiltrados) && alunosFiltrados.map((aluno) => (
                                        <li key={aluno.cp_id}>{aluno.cp_nome}</li>
                                    ))}
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeViewModal}>Fechar</Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default Turmas;

